/*
 * Copyright (c) 2023. Collabro Limited
 */

import React, { useState } from "react";
import { Credentials, VantageUser } from "../interface/credentials";
import NotAuthenticated from "./NotAuthenticated/NotAuthenticated";
import Authenticated from "./Authenticated/Authenticated";
import LoadingScreen from "./Helper/LoadingScreen";
import { useQuery } from "@tanstack/react-query";
import { checkAuthStatus } from "../api";

const RosterApp = () => {
  const [loggedInUser, setLoggedInUser] = useState<VantageUser | null>(null);
  const [logout, setLogout] = useState(false);

  const { isFetching, isLoading } = useQuery({
    queryKey: ["user"],
    queryFn: checkAuthStatus,
    enabled: loggedInUser === null && !logout,
    retry: false,
    refetchOnWindowFocus: false,
    onSuccess: (data: Credentials) => {
      loggedInUser === null && setLoggedInUser(data.principal);
    },
    onError: () => {
      setLoggedInUser(null);
    },
  });

  if (isLoading || isFetching) return <LoadingScreen />;

  return (
    <>
      {!loggedInUser || logout ? (
        <NotAuthenticated
          setLoggedInUser={setLoggedInUser}
          setLogout={setLogout}
          logout={logout}
        />
      ) : (
        <Authenticated
          loggedInUser={loggedInUser}
          setLoggedInUser={setLoggedInUser}
          setLogout={setLogout}
          logout={logout}
        />
      )}
    </>
  );
};

export default RosterApp;
